import EcommerceDashboardContainer from "../../Componant/Dashboard/EcommerceDashboard/index"

const EcommerceDashboard = () => {
  return (
    <div className="page-body">
      <EcommerceDashboardContainer />
    </div>
  );
};

export default EcommerceDashboard;
